import { createContext, useContext, useState } from "react";
import { useQueryClient } from "react-query";
import constants from "../utils/Constants";
import { logoutServ } from "../services/login-service";

const AuthContext = createContext();

export function AuthContextProvider({ children }) {
    let token = localStorage.getItem('token') || null;
    const initialValue = token ? userFromToken(token) : null;
    const [ctxtUser, setCtxtUser] = useState(initialValue);
    const [loading, setLoading] = useState(false);
    const [navCom, setNavCom] = useState({ comId: "" })
    const [currProjArr, setCurrProjArr] = useState([]);
    let asyncTimeout;
    const queryClient = useQueryClient();
   


    function ctxtlogin(res) {
        let token = localStorage.getItem('token');

        if (!token) {
            localStorage.setItem('token', res.token);
            token = res.token;
        }
        const tokenData = userFromToken(token)

        setCtxtUser({ ...tokenData })
    }

    function userFromToken(token) {
        const tokenData = parseJwt(token);
        const isComUser = constants.comUserArr.includes(tokenData?.userType);
        return {
            token,
            userId: tokenData.userId,
            userType: tokenData.userType,
            sessionToken: tokenData.sessionToken,
            comId: tokenData.comId,
            comName: tokenData.comName,
            comLogo: tokenData.comLogo,
            isComUser
        }
    }

    function parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    };

    async function ctxtlogout() {
        await logoutServ();
        setCtxtUser(null);
        localStorage.clear();
        queryClient.removeQueries();
    }

    function setLoadingScreen(value) {
        setLoading(value)
    }

    function setAsyncLoading(value) {
        if (value === true) {
            asyncTimeout = setTimeout(() => {
                // console.log("In time out fn-------------setAsyncLoading");
                setLoading(true);
            }, 1000);
        }
        else {
            setTimeout(() => setLoading(false), 1000);
            clearTimeout(asyncTimeout);
        }
    }

    function setNavComValue({ comId }) {
        setNavCom({ comId })
    }
    function setCurrProjArrVal(arr) {
        setCurrProjArr(arr);
    }



    const value = {
        ctxtUser,
        ctxtlogin,
        ctxtlogout,
        loading,
        setLoadingScreen,
        setAsyncLoading,
        navCom, setNavComValue,
        currProjArr, setCurrProjArrVal
    }
    return <AuthContext.Provider value={value}>
        {children}
    </AuthContext.Provider>
}

export function useAuthContext() {
    return useContext(AuthContext);
}